import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { useTrackEvent } from '../../segment/segment';
import { EventTypeEnum } from '../../segment/types';
import { selectedClientInfoAtom } from '../state';
import { useGetMeasuresByPatientShortId } from '../useGetMeasuresByPatientShortId';
import { ClientInformationDrawer } from './ClientInformationDrawer';

export function ClientInformationDrawerWrapper() {
  const selectedClient = useAtomValue(selectedClientInfoAtom);
  // Ensures patient measures are fetched when a provider opens the drawer via the upcoming appointment list
  useGetMeasuresByPatientShortId(selectedClient?.patientShortId);

  const { userViewed } = useTrackEvent();

  useEffect(function trackClientInfoDrawerViewed() {
    userViewed(EventTypeEnum.CLIENT_INFO, {
      patientShortId: selectedClient?.patientShortId ?? '',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ClientInformationDrawer
      selectedPatientShortId={selectedClient?.patientShortId}
      visitorName={selectedClient?.name ?? 'Client Information'}
      visitorStatus={selectedClient?.status}
      visitorUuid={selectedClient?.visitorUuid}
      isEmpty={!selectedClient}
    />
  );
}
